import React from 'react';
import { cn } from '../../lib/utils';

const Alert = React.forwardRef(
  ({ className, variant = 'default', children, ...props }, ref) => {
    const variantClassNames = {
      default: 'bg-gray-100 text-gray-800 border-gray-200',
      primary: 'bg-indigo-50 text-indigo-900 border-indigo-200',
      success: 'bg-green-50 text-green-900 border-green-200',
      warning: 'bg-yellow-50 text-yellow-900 border-yellow-200',
      destructive: 'bg-red-50 text-red-900 border-red-200',
    };

    return (
      <div
        ref={ref}
        role="alert"
        className={cn(
          'p-4 rounded-md border',
          variantClassNames[variant],
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <h5 ref={ref} className={cn('font-medium mb-1', className)} {...props}>
      {children}
    </h5>
  )
);

AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cn('text-sm', className)} {...props}>
      {children}
    </div>
  )
);

AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription };
